import classNames, { ArgumentArray } from "classnames";
import { twMerge } from "tailwind-merge";

export const cx = (...args: ArgumentArray) => twMerge(classNames(args));
